import React, { useCallback, useMemo } from 'react';
import { CustomMarker } from 'components/Map';

import type { Cluster } from '../../utils/cluster/cluster';
import { zoomIn } from '../../actions/mapV2';
import { useAppDispatch } from '../../stores/hooks';

import styles from './ClusterMarker.module.scss';

interface Props {
  cluster: Cluster<{ count: number }>;
}

const ClusterMarker: React.FC<Props> = ({ cluster }) => {
  const dispatch = useAppDispatch();
  const doZoomIn = useCallback(
    (center: { lat: number; lon: number }) => dispatch(zoomIn(center)),
    [dispatch],
  );

  const position = useMemo(
    () => ({ lat: cluster.geometry.coordinates[1], lon: cluster.geometry.coordinates[0] }),
    [cluster.geometry.coordinates],
  );

  const marker = useMemo(
    () => (
      <svg width="54px" height="54px">
        <g>
          <circle cx="27" cy="27" r="24" />
        </g>
        <text x="27" y="28.5">
          {cluster.properties.count}
        </text>
      </svg>
    ),
    [cluster.properties.count],
  );

  return (
    <CustomMarker
      // Incorrect types in quiver-react
      // @ts-ignore
      position={position}
      icon={marker}
      className={styles.clusterMarker}
      iconSize={[54, 54]}
      eventHandlers={{ click: () => doZoomIn(position) }}
    />
  );
};

export default ClusterMarker;
